import React from 'react'
import style from 'css/admin/dashboard.module.css';

function GraphIndex({ total, used }) {
    const formatNumber = (value) => {
        const num = Number(value);
        if (Number.isNaN(num)) return value;
        return num.toLocaleString();
    };
    const fields = [
        { key: 'total', title: '전체', colorClass: style.total, value: total },
        { key: 'used', title: '사용중', colorClass: style.used, value: used },
        { key: 'remain', title: '잔여', colorClass: style.remain, value: total - used },
    ];

    return (
        <div className={style.index_wrapper}>
            {fields.map((field) => (
                <div key={field.key} className={style.index_container}>
                    <div className={style.index_label}>
                        <div className={`${style.circle} ${field.colorClass}`}></div>
                        <span className={style.title}>{field.title}</span>
                    </div>
                    <div className={`${style.index_quantity} ${field.colorClass}`}>
                        {formatNumber(field.value)}
                    </div>
                </div>
            ))}
        </div>
    )
}

export default GraphIndex
